export const getResourceGridDataFixedCacheKey = (masterGridId: string) => {
  return `${masterGridId}-postUsersMeV2OrganisationsCurrentByTypeResources-resource-grid-data-fixed-cache-key`;
};

export const getResourceGridResourceProtectionFixedCacheKey = (
  resourceIds: string[],
  accountId: string,
) => {
  return `${resourceIds.join(accountId)}-patchUsersMeAccountsByAccountIdResources-resource-protection-fixed-cache-key`;
};
